import PropTypes from 'prop-types';
import React from 'react';
import { Tag } from 'antd';

function PositionBadge({ type, label, icon, selected = false, active = false, disable = false }) {
  return (
    <Tag
      className={`ads-marker-tag ads-marker-tag--${type} ${
        selected ? 'ads-marker-tag--selected' : ''
      } ${active ? 'ads-marker-tag--active' : ''} ${disable ? 'ads-marker-tag--disable' : ''}`}
      icon={icon}
    >
      {label}
    </Tag>
  );
}

PositionBadge.propTypes = {
  selected: PropTypes.bool,
  active: PropTypes.bool,
  disable: PropTypes.bool,
  icon: PropTypes.object,
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default PositionBadge;
